import { render, staticRenderFns } from "./indexFree.vue?vue&type=template&id=2640c4e5&scoped=true&"
import script from "./indexFree.vue?vue&type=script&lang=js&"
export * from "./indexFree.vue?vue&type=script&lang=js&"
import style0 from "./indexFree.vue?vue&type=style&index=0&id=2640c4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640c4e5",
  null
  
)

export default component.exports